
import GridEraser from "../../../assets/outline/GridEraser.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function GridEraserIcon({ className, dataTestid = "GridEraserIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <GridEraser data-testid={dataTestid} className={classes} {...rest} />
  );
}
